import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import {useGetMyMultiFactorAuthenticationSettingsQuery} from '@dms/api/base';
import i18n from '@dms/i18n';

import {MyProfileTemplate} from '../../components/MyProfileTemplate/MyProfileTemplate';
import {DeactivatedInfo} from './components/DeactivatedInfo';
import {PairAuthDevice} from './components/PairAuthDevice';
import {PairedInfo} from './components/PairedInfo';

export function MultiFactorAuthentication() {
  const {
    data: userMfaSettings,
    isLoading,
    isError,
  } = useGetMyMultiFactorAuthenticationSettingsQuery();
  const isCurrentUserSetUp = isNotNil(userMfaSettings?.activatedAt);
  const isDeactivated = isNotNil(userMfaSettings?.deactivatedAt);

  const detailComponent = match([isCurrentUserSetUp, isDeactivated])
    .with([false, true], () => <DeactivatedInfo />)
    .with([false, false], () => <PairAuthDevice />)
    .otherwise(() => <PairedInfo />);

  return (
    <MyProfileTemplate
      isLoading={isLoading}
      isError={isError}
      header={{
        title: i18n.t('page.settings.labels.multiFactorAuth'),
        breadcrumbs: [
          {label: i18n.t('entity.user.labels.myProfile'), isCurrentPage: true},
          {label: i18n.t('page.myProfile.labels.multiFactorAuth'), isCurrentPage: true},
        ],
      }}
    >
      {detailComponent}
    </MyProfileTemplate>
  );
}
